import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

import * as st from './Panel.module.scss'

interface PanelProps extends BaseComponentProps {
    forceLastLine?: boolean
}

export const Panel: React.ComponentType<PanelProps> = props => {
    const className = extractClassNamesFromProps(props, st.panel,
    {
        [st.forceLastLine]: Boolean(props.forceLastLine)
    })
    return <div className={className}>{props.children}</div>
}

export const PanelSection: React.ComponentType<PanelProps> = props => {
    const className = extractClassNamesFromProps(props, st.panelsection,
    {
        [st.forceLastLine]: Boolean(props.forceLastLine)
    })
    return <div className={className}>{props.children}</div>
}

// Add displayName to preserve the component name on snapshot testing
Panel.displayName = 'Panel'
PanelSection.displayName = 'PanelSection'
